<script setup lang="ts">
import VsAlert from '@/components/vision/VsAlert.vue'
import VsButton from '@/components/vision/VsButton.vue'
import VsText from '@/components/vision/VsText.vue'

const emits = defineEmits<{
  (event: 'update-schema-requested')
}>()

const updateBtnClicked = () => {
  emits('update-schema-requested')
}
</script>

<template>
  <VsAlert type="info">
    <VsHeading class="mb-2" type="overline">New fields available</VsHeading>
    <div class="d-flex">
      <!-- Deliberately have the closing bracket on newline because VsText has
      `white-space: pre-wrap` for some reason. VsText is used often, so it's
      risky to remove that style. -->
      <VsText type="caption" class="mr-2"
        >Updating will replace the current fields and data with the new version.
      </VsText>
      <VsButton
        style="background-color: white"
        small
        label="Update"
        type="secondary"
        @click="updateBtnClicked"
      />
    </div>
  </VsAlert>
</template>
